import { FormattedMessage, useIntl } from 'react-intl'
import { array, bool } from 'prop-types'
import PopupNew from '../../../components/popup-new'
import { popupSize } from '../../../components/popup-new/constants'

const CancelWarningPopUp = ({ rightPopupButtons, authorized }) => {
  const intl = useIntl()
  return (
    <>
      {authorized && (
        <PopupNew
          rightButtons={rightPopupButtons}
          size={popupSize.SMALL}
          bodyPadding="16px 32px"
          width={640}
          trueCenter
          title={intl.formatMessage({ id: 'alert_popup_title' })}
        >
          <FormattedMessage id="projectSettings_pendingChanges" />
        </PopupNew>
      )}
    </>
  )
}

CancelWarningPopUp.propTypes = {
  rightPopupButtons: array,
  authorized: bool,
}

export default CancelWarningPopUp
